import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { selectLanguageArea } from '@ninety/platform/state';
import { BillingStateActions } from '@ninety/platform/state/app-global/billing/billing-state.actions';
import { TerraIconModule } from '@ninety/terra';
import { NinetyCMModule } from '@ninety/ui/core';
import { FilterBarActions } from '@ninety/web/pages/shared/layouts';

/**
 * This is just an example tiered page for issues.
 * Mainly to help demonstrate how the 'hasFeatureAccessGuard' route guard  works.
 * This is meant for the team to replace with their own content or completely remove if not needed.
 * */
@Component({
  selector: 'ninety-issues-tiered-page',
  standalone: true,
  imports: [TerraIconModule, NinetyCMModule, LetDirective],
  template: `<ninety-cm-tiered-page *ngrxLet="issueLang$ as language">
    <div headline>Resolve {{ language.items }} and Stay On Track</div>
    <div description>
      Access the {{ language.items }} tool to Raise, Discuss, and Resolve blockers in real time, keeping your team
      aligned and projects on track.
    </div>
    <button ninety-cm-button (click)="onExplorePlansClick()">
      <terra-icon icon="lightning" variant="fill" />
      Explore Essentials Plan
    </button>
    <a href="https://help.ninety.io/introduction-to-issues" rel="external" target="_blank"
      >Learn more about {{ language.longTerm }} {{ language.items }}</a
    >
  </ninety-cm-tiered-page>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IssuesTieredPageComponent implements OnInit {
  @Input() hideFilterBar = true;
  private readonly store = inject(Store);
  protected readonly issueLang$ = this.store.select(selectLanguageArea('issue'));

  ngOnInit() {
    if (this.hideFilterBar) {
      this.store.dispatch(FilterBarActions.hide());
    }
  }

  onExplorePlansClick(): void {
    this.store.dispatch(BillingStateActions.openPricingPlansModal());
  }
}
